import React from 'react'
import {Row, Col} from 'antd';
import './item-buscador-lateral.scss';

const ItemBuscadorLateral = props =>{
    
    const {onClick, selecionado, children} = props;

    let classNameSelecionado = ""
    if(selecionado){
        classNameSelecionado = "selecionado";
    }

    return (
    <Row onClick={onClick} className={["item", classNameSelecionado]} {...props}>
        <Col span={24}>
            {children}
        </Col>
    </Row>
    );
}

export {ItemBuscadorLateral};